module.exports = __webpack_public_path__ + "img/EZ-Self-2.9d8020fd.png";